import { Circle, Square } from 'lucide-react';

interface RecordingControlProps {
  isPaused: boolean;
  isPending: boolean;
  onPause: () => void;
  onResume: () => void;
}

/**
 * Practitioner-only pill rendered inside the floating CallControlBar.
 * Toggles between "Start recording" and "Stop recording" based on local
 * isPaused state. Disabled while the underlying mutation is pending.
 * The top-left CallStatusChip still reads "Paused" / "Rec".
 */
export function RecordingControl({
  isPaused,
  isPending,
  onPause,
  onResume,
}: RecordingControlProps) {
  const label = isPaused ? 'Start recording' : 'Stop recording';
  const onClick = isPaused ? onResume : onPause;

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isPending}
      aria-label={label}
      className="inline-flex h-10 items-center gap-2 rounded-full px-3 text-white/85 transition-colors hover:bg-white/8 focus-visible:ring-2 focus-visible:ring-[#35816E] focus-visible:ring-offset-2 focus-visible:ring-offset-[#0F1F1C] focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-60 @xl:px-3.5"
    >
      {isPaused ? (
        <Circle
          className="h-3 w-3 fill-[#D4A017] text-[#D4A017]"
          aria-hidden="true"
          strokeWidth={0}
        />
      ) : (
        <Square
          className="h-3.5 w-3.5 fill-[#D4A017] text-[#D4A017]"
          aria-hidden="true"
          strokeWidth={0}
        />
      )}
      <span className="hidden text-[13px] @xl:inline">{label}</span>
    </button>
  );
}
